import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 10px;
  }
  
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    padding: 0;
    margin: 0;
  }

  html, 
  body, 
  #root {
    height: 100vh;
  }

  body {
    font-family: "Catamaran", sans-serif;
    font-size: 1.6rem;
    font-weight: 400;
    background: #181818;
  }

  h1,
  h2,
  h3 {
    color: #fff;
  }

  p {
    color: rgb(169, 169, 169);
  }

  img {
    max-width: 100%;
  }

  button,
  textarea,
  input {
    outline: none;
    border: none;
  }
  
  i,
  button {
    cursor: pointer;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #888; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #555;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`;
